<template>
  <component :is="is" :class="classes">
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { colorClasses } from '../util/colorMap'

const props = defineProps({
  is: {
    type: String,
    default: 'p',
  },
  color: {
    type: String,
    default: 'text-gray-600',
  },
  dark: String,
  size: {
    type: String,
    default: 'text-sm',
  },
  font: {
    type: String,
    default: 'font-normal',
  },
  class: {
    type: String,
    default: '',
  },
})

const lightAndDarkColorClasses = computed(() => {
  // If dark colors have been overridden...
  if (props.dark) return [props.color, props.dark].join(' ')

  return colorClasses(props.color)
})

const classes = computed(() => {
  return [
    props.size,
    props.font,
    lightAndDarkColorClasses.value,
    props.class,
  ].join(' ')
})
</script>
